<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">GPON Config</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the ont find config and other globle configuration." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--find list-->
        <pane label="Find List">
          <find-list ></find-list>
        </pane>
        <!--find config-->
        <pane label="Find Config">
          <find-config ></find-config>
        </pane>
        <!--auot config-->
        <pane label="Auto Config">
          <auto-config ></auto-config>
        </pane>
      </tabs>
    </div>
  </div>
</template>

<script>

import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import FindList from "@/views/GponFindList.vue"
import FindConfig from "@/views/GponFindConfig.vue"
import AutoConfig from "@/views/GponAutoConfig.vue"

export default {
  data() {
    return {
      activeIndex: 0,
    }
  },
  components: {
    tabs,
    pane,
    FindList,
    FindConfig,
    AutoConfig,
  },
  created() {},
  methods: {},
}
</script>